<template>
  <section>
    <h2 class="h2Title">역할 관리</h2>
    <div class="dashWrap">
      <div class="dashRow">
        <div class="dashBx">
<!--          <h2 class="tit">역할 목록</h2>-->
          <v-text-field v-model="filter" label="역할명을 입력해주세요." dense clearable outlined/>
          <tree :data="treeData" :options="treeOptions"
                :filter="filter"
                @node:clicked="roleClick"
                @node:dragging:finish="moveRole"
                ref="roleTree">

            <span class="tree-text" slot-scope="{ node }">
              <div class="node-text"><i :class="[node.data.activated ? 'fa fa-check-circle' : 'fa fa-ban']"></i> {{ node.text }}
                <i class="mdi mdi-pencil" @click.stop="updateRoleForm(node)"  v-if="!node.data.default"> </i>
                <i class="mdi mdi-delete" @click.stop="deleteRole(node)"  v-if="!node.data.default"> </i>
              </div>
            </span>

          </tree>

          <v-dialog v-model="dialogVisible" max-width="500px" @click:outside="dialogVisible = false" @keydown.esc="dialogVisible = false">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>

                  <v-form ref="formRole" @submit.prevent="">
                    <v-row>
                      <v-col class="wh300">
                        <v-text-field v-model="roleObj.roleName" :rules="[rules.required]" label="역할 명" @keydown.enter="saveRole"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="wh300">
                        <v-select :items="flagItems" item-value="value" item-text="text" v-model="roleObj.activated"
                                  dense solo clearable flat outlined required
                                  :rules="[rules.required]" label="사용여부"/>
                      </v-col>
                    </v-row>
                  </v-form>

                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogVisible = false">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="saveRole">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </div>
        <div class="btnStyleBx">
          <div class="btnCommon justify-center">
            <v-btn class="vIconResize" @click="crateRoleForm">
              <v-icon left>mdi mdi-playlist-plus</v-icon> 역할 추가
            </v-btn>
          </div>
        </div>
      </div>


      <div class="dashRow">
        <div class="dashBx">
        <v-tabs>
          <v-tabs-slider></v-tabs-slider>

          <v-tab href="#tab-1">
            <v-icon>mdi-menu</v-icon>
            메뉴 접근 관리
          </v-tab>

          <v-tab href="#tab-2">
            <v-icon>mdi-access-point-network</v-icon>
            EndPoint 접근 관리
          </v-tab>


          <v-tab-item value="tab-1" key="1">
            <h2 class="tit arrowLink d-flex align-center justify-space-between">
              <span>{{groupName}} 역할 메뉴 목록</span>
            </h2>
            <menu-list :role="this.roleProp"/>
          </v-tab-item>
          <v-tab-item value="tab-2" key="2">
            <h2 class="tit arrowLink d-flex align-center justify-space-between">
              <span>{{groupName}} 역할 EndPoint 목록</span>
            </h2>
            <endpoint-list :role="this.roleProp"/>
          </v-tab-item>
        </v-tabs>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import LiquorTree from 'liquor-tree';


import _ from 'lodash';
import roleApi from '@/api/RoleApi';

import EndpointList from "@/views/role/component/EndpointList";
import MenuList from "./component/MenuList";

async function list() {

  let roles = await roleApi.list()
  // console.log(roles);
  // const datasets = roles?.content??[];
  // datasets.forEach(t => genTree(t, 1));
  roles.forEach(t => genTree(t, 1));
  return roles;
}
const genTree = (item, depth) => {
  item.data = _.cloneDeep(item);
  item.options = {dropable: false};
  item.child && item.child.forEach(t => genTree(t, depth+1));
}


export default {
  name: 'Role',
  components: {
    [LiquorTree.name]: LiquorTree,
    'endpoint-list': EndpointList,
    'menu-list': MenuList
    // ValidationProvider
  },
  data: () => ({
        fav: true,
        treeData: list(),
        treeOptions: {
          parentSelect: true,
          propertyNames: {
            state: 'options',
            text: "roleName",
            children: "child"
          },
          dnd:false,
          filter: {
            // matcher(query, node) {
            //   return new RegExp(query, 'i' ).test(node.data.roleName)
            // },
            emptyText: '일치하는 역할이 없습니다.'
          }
        },
        roleObj: {},
        roleProp: {},
        node:{},
        roleList: {},
        formTitle: '역할 추가',
        dialogVisible: false,
        flagItems: [
          {
            value: true,
            text: '사용'
          },
          {
            value: false,
            text: '사용안함'
          }
        ],
        filter: null,
        rules: {
          required: value => !!(value || value === false || value === true) || '필수 입력 항목입니다..'
        },
        errorMessages: '',
        groupName: ''
      }
  ),
  methods: {
    duplicatedCheck() {
      if(!this.roleObj.role){
        return false;
      }
      let duplicateCheckResult = this.recursiveRoleCheck(this.roleList);
      this.errorMessages = duplicateCheckResult
          ? '이미 사용중인 코드입니다.' : ''

      return ! duplicateCheckResult;
    },
    recursiveRoleCheck(roleList) {
      return roleList.some(c => {
        if( c.child && c.child.length > 0 )
          return c.role.toUpperCase() === this.roleObj.role.toUpperCase() || this.recursiveRoleCheck(c.child);
        else
          return c.role.toUpperCase() === this.roleObj.role.toUpperCase()
      })
    },
    async roleClick(node) {
      if(this.roleProp === node.data) {
        // await this.$refs.roleTree.unselect();
        await node.select(false);
        node.unselect();
        // this.node = {};
        this.roleProp = {};
        this.groupName = '';
      } else {
        // this.node = node;
        this.roleProp = node.data;
        this.groupName = node.data.roleName;

      }
      this.dialogVisible = false;

      // this.$refs.formRole.reset();

    },
    crateRoleForm() {
      this.$refs.formRole?.resetValidation();
      this.roleObj = {};
      this.dialogVisible = true;
      this.formTitle = '역할 추가';
    },
    updateRoleForm(role) {
      // this.$refs.formRole?.reset();
      this.roleObj = _.cloneDeep(role.data);
      this.node = role;
      this.dialogVisible = true;
      this.formTitle = '역할 수정';
    },
    async saveRole() {
      if(!this.$refs.formRole.validate())
        return false;

      let c;
      if(!this.roleObj.roleId) {
        c = await roleApi.saveRole(this.roleObj);
        const r = {
          text: c.roleName,
          data: c,
          state: { selected: true, dropable: false }
        };
        if(this.$refs.roleTree)
          this.$refs.roleTree.prepend(r);
        else
          this.$refs.roleTree.append(r);
        this.roleObj = c;

      } else {
        let data = await roleApi.saveRole(this.roleObj);
        data.text = data.roleName;
        data.data = _.cloneDeep(data);
        Object.assign(this.node, data);
      }

      this.dialogVisible = false;
    },
    async deleteRole(role) {
      this.node = role;
      if(role.children && role.children.length !== 0) {
        alert("하위 역할이 존재합니다.");
        return false;
      }
      if (confirm(`${role.text} 역할을 삭제하시겠습니까?`)) {
        roleApi.deleteRole(role.data.roleId).then(() => {
          this.node.remove();
          this.roleObj = {};
          this.roleProp = {};
          this.groupName = '';
          this.dialogVisible = false;
        });
      }
    },
    async moveRole(moveNode, destinationNode, pos) {
      let position = new Map();
      position.set('DRAG-ABOVE', 'up');
      position.set('DRAG-BELOW', 'down');
      position.set('DRAG-ON', 'in');

      await roleApi.moveRole(moveNode.data.role, destinationNode.data.role, position.get(pos.toUpperCase()));
    }
  },
  async created() {
    // this.roleList = await this.treeData;
  }

}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}


.dashWrap {
  display: flex;
  flex-flow: row wrap;
}

.dashRow:first-child {
  flex: 0 1 20%;

  &:first-child {
    margin-right: 2%;
  }
}
.dashRow:nth-child(2) {
  flex: 0 1 75%;

}
.tit {
  margin-top: 30px;
  margin-left: 5px;
  margin-bottom: 10px;
  font-size: 18px;
}

.dashBx {
  padding: 20px;
  border: 1px solid #e9e9e9;

  .state {
    padding-top: 37px;
    padding-bottom: 37px;
    cursor: pointer;
    color: #666;

    dt {
      display: flex;
      justify-content: center;
      align-items: baseline;
      margin-bottom: 20px;

      em {
        margin-right: 5px;
        font-size: 50px;
        font-weight: bold;
        color: #333;
      }
    }

    dd {
      font-weight: 500;
    }
  }

  .deposit {
    display: flex;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      flex: 0 0 38%;

      &:nth-child(3) {
        flex: 0 0 24%;
      }

      .depositTit {
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 25px;
        background: #f6f6f6;
        font-size: 13px;
        font-weight: 600;
        color: #555;
        text-align: center;
      }

      .depositNum {
        display: flex;
        padding-top: 50px;
        padding-right: 30px;

        p {
          margin-right: 50px;

          em {
            font-size: 40px;
            font-weight: bold;
          }
        }
      }
    }
  }

}

.h3Title {
  @include h3-title;
}
.tabContent{
  .formInfo {
    @include form-info;
  }
  .formInfoArea{
    &.align-normal{
      align-items: normal !important;
    };
    padding: 10px 10px 0 0;
    font-size: 13px;
    font-weight: 600;
    &.small{
      flex: 0 0 130px;
      width: 130px;
    }

  }
  .list{
    display: flex;
    width: 100% !important;
    img{
      width: 100%;
      height: auto;
    }
  }
  .wh300{
    width: 300px;
    padding: 0;
  }
}
</style>